import {Box, Button, CircularProgress, Typography} from "@material-ui/core";
import React from "react";
import {T} from "@tolgee/react";
import GoogleIcon from "view/images/GoogleIcon";
import useStyles from "./style";

interface Props {
  onClick: () => void;
  /** `global.login.sign_in_with_google` or `global.sign_up.sign_up_with_google`. */
  labelKey: string;
  disabled?: boolean;
  isLoading?: boolean;
  /** Renders the `or` rule above the button (login page only). */
  withDivider?: boolean;
  /** Marks this as the way in the browser used last. */
  isLastLogin?: boolean;
}

const GoogleSignInButton = ({
  onClick,
  labelKey,
  disabled = false,
  isLoading = false,
  withDivider = false,
  isLastLogin = false,
}: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {withDivider && (
        <Box className={classes.divider}>
          <T keyName="global.login.or_divider" />
        </Box>
      )}
      <Button
        variant="outlined"
        disableElevation
        className={classes.button}
        onClick={onClick}
        disabled={disabled || isLoading}
      >
        <span className={classes.label}>
          {isLoading ? <CircularProgress size={20} /> : <GoogleIcon />}
          <T keyName={labelKey} />
        </span>
      </Button>
      {isLastLogin && (
        <Typography variant="body2" className={classes.lastLoginCaption}>
          <T keyName="global.login.last_login" />
        </Typography>
      )}
    </Box>
  );
};

GoogleSignInButton.defaultProps = {
  disabled: false,
  isLoading: false,
  withDivider: false,
  isLastLogin: false,
};

export default GoogleSignInButton;
